import { render, staticRenderFns } from "./ruleModal.vue?vue&type=template&id=3583c146&scoped=true"
import script from "./ruleModal.vue?vue&type=script&lang=js"
export * from "./ruleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583c146",
  null
  
)

export default component.exports